import { SolvedChart } from '../solve/assignValues'

const COMPRESS_THRESHOLD = 20
const NEIGHBORHOOD = 2
const TAIL_BARS = 8

/**
 * Broken-axis selection (spec §8): a wide axis (deep offsets/lookbacks) renders
 * only the bars near constraints plus the recent tail, never a uniform strip
 * where PRNG filler crushes the constrained bars into a hairline. Returns the
 * ascending bar indices to draw; a gap glyph goes wherever consecutive entries
 * are not adjacent.
 */
export const visibleBars = (chart: SolvedChart): number[] => {
  if (chart.axisLength <= COMPRESS_THRESHOLD) {
    return Array.from({ length: chart.axisLength }, (_, bar) => bar)
  }
  const keep = new Set<number>()
  for (let bar = chart.axisLength - TAIL_BARS; bar < chart.axisLength; bar += 1) {
    keep.add(bar)
  }
  chart.badges.forEach((badge) => {
    if (badge.bar !== undefined) {
      for (let bar = badge.bar - NEIGHBORHOOD; bar <= badge.bar + NEIGHBORHOOD; bar += 1) {
        keep.add(bar)
      }
    }
    if (badge.window) {
      keep.add(badge.window.from)
      keep.add(badge.window.to)
    }
  })
  return Array.from(keep)
    .filter((bar) => bar >= 0 && bar < chart.axisLength)
    .sort((a, b) => a - b)
}
